import type { CatalogItem } from '../models/types';
import { ItemArt } from '../avatar/itemArt';
import { rarityColors, withAlpha } from '../theme';
import { RarityBadge } from './RarityBadge';

/** Grid tile for an owned item: big item art on the item's palette colour. */
export function ItemCard({ item, onClick, assembled = false, wearing = false }: { item: CatalogItem; onClick?: () => void; assembled?: boolean; wearing?: boolean }) {
  return (
    <button
      type="button"
      className="item-card"
      onClick={onClick}
      data-testid={`item-card-${item.id}`}
      style={{ background: withAlpha(item.palette, 0.9), borderColor: rarityColors[item.rarity] }}
    >
      {wearing && <span className="wearing-tag">Wearing</span>}
      <ItemArt item={item} className="emoji" />
      <span className="name">{item.name}</span>
      <span style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
        <RarityBadge rarity={item.rarity} compact />
        {assembled && <span aria-label="assembled">🧩</span>}
      </span>
    </button>
  );
}
